import type { CSSProperties } from 'react';

type ResponsiveEmptyStateIllustrationProps = {
  src: string;
  alt: string;
  maxWidth: number;
  alignment?: 'center' | 'left';
  height?: CSSProperties['height'];
  maxHeight?: CSSProperties['maxHeight'];
};

export const ResponsiveEmptyStateIllustration = ({
  src,
  alt,
  maxWidth,
  alignment = 'center',
  height = '100%',
  maxHeight = '100%',
}: ResponsiveEmptyStateIllustrationProps) => (
  <div
    style={{
      alignItems: 'center',
      display: 'flex',
      height,
      justifyContent: alignment === 'left' ? 'flex-start' : 'center',
      minHeight: 0,
      minWidth: 0,
      width: '100%',
    }}
  >
    <img
      src={src}
      alt={alt}
      style={{
        display: 'block',
        height: 'auto',
        maxHeight,
        maxWidth: `min(100%, ${maxWidth}px)`,
        minWidth: '640px',
        objectFit: 'contain',
      }}
    />
  </div>
);
